const typeConf = Object.freeze({
  default: Object.freeze({
    base: 16,
    minPadding: 2,
    ratio: 2,
    rhythmUnit: 6,
    steps: 5,
  }),
  xl: Object.freeze({
    base: 18,
    minPadding: 2,
    ratio: 2,
    rhythmUnit: 7,
    steps: 5,
  }),
});

export default typeConf;
